module.exports = __webpack_public_path__ + "static/media/warnig-invoices.78c29c61.svg";